import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { UserRecord } from '../entities/records';
import * as selectors from '../entities/User/selectors';

function mapStateToProps(state, { userIds }) {
  return {
    users: selectors.usersByIds(state, userIds),
  };
}


export default compose(
  setPropTypes({
    userIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  }),
  connect,
  setPropTypes({
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserRecord)),
  }),
)(mapStateToProps);
